var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrapper"},[(_vm.ready)?_c(_vm.layout,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }